import React from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css"; // Default Flatpickr style
import "./DatePickerStyles.css"; // Custom styles for date picker
import { CircularProgress } from "@mui/material";

const DatePicker = ({
  label,
  date,
  onChange,
  disabled,
}: {
  label: string;
  date: Date;
  onChange: (date: Date) => void;
  disabled?: boolean;
}) => {
  if (disabled === true) {
    return (
      <div style={{ width: "226px" }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="flex flex-col space-y-2">
      {label && <label className="text-xs font-medium text-gray-700">{label}</label>}
      <Flatpickr
        value={date}
        options={{
          altInput: true,
          altFormat: "F j, Y",
          dateFormat: "Y-m-d",
        }}
        onChange={([selectedDate]) => onChange(selectedDate)}
        className="custom-date-picker px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-600 focus:border-primary-600"
      />
    </div>
  );
};

export default DatePicker;
